module.exports = __webpack_public_path__ + "static/media/anuncio.72091957.jpg";